import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ToolbarButton } from '../../models/toolbar-button/toolbar-button';
import { IsbComponent } from './isb/isb.component';
import { IsbPackageComponent } from './isb-package/isb-package.component';



const routes: Routes = [
  {
    path: '',
    component: IsbComponent,
    data: {
      activeLink: ToolbarButton.CATALOGUE
    },
    title: 'Isb',
  },
  {
    path: 'isbPackages',
    component: IsbPackageComponent,
    title: 'ISB Packages',
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ViewRequestRoutingModule { }
